module.exports = __webpack_public_path__ + "static/CloudSmart_826-1731dafe52ba98beeb15bd2c85ee8501.png";